<template>
    <a :href="artist.uri" class="artist-avatar">
        <img :src="artist.imageUris.avatarSm.url" :alt="artist.name" width="41" height="41" class="rounded-circle">
        <span class="name d-inline-block ml-2" v-if="withName">{{ artist.name }}</span>
    </a>
</template>

<script>
    export default {
        props: {
            artist: {
                type: Object,
                default: null
            },
            withName: {
                type: Boolean,
                default: true
            }
        },

        mounted() {
        },

        methods: {
        }
    }
</script>
